import { makeAutoObservable, observable, toJS  } from "mobx";
import moment from "moment";

import HighlightWeek, {
  getCurrentUser,
} from "../../../../Utility/modules/helpers";
import { highlightService } from "../services/highlightservice";

class HighLightStore {
  constructor() {
    makeAutoObservable(this);
  }

  showAddHighlightDialog = false;
  highlightType = "";
  selectedWeekName = "";
  prodYear = moment().format("YYYY");
  selDate = new Date();
  selectedWeek = String(HighlightWeek.getWeeK());
  selectedMonth = moment().month();
  isSaving = false;
  isLoading=false;
highlight={highlightId:0};
  lowlightDescription = "";
  highlightDescription = "";
  weeks = [];

  loadWeeks() {
    this.weeks = [];
    for (let idx = 1; idx <= 52; idx++) {
      this.weeks.push({
        text: `WK${idx.toString()}: ${HighlightWeek.getDateRangeByYear(
          idx,
          this.prodYear
        )}`,
        key: String(idx),
      });
    }
  }
  async loadHighlight(assetId) {
 try {
      this.isLoading = true;

     
       const retVal=await highlightService.getHighlightByWeek(this.selectedWeek,assetId);
        console.log("retVal", retVal);
        if(!retVal){
this.lowlightDescription="";
this.highlightDescription="";
this.highlight={highlightId:0};
        }else{
      this.highlight=retVal;
       this.lowlightDescription=retVal.lowlightDescription
       this.highlightDescription=retVal.highlightDescription
        }
      
      
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }

  }
  async save(highlight) {
    try {
      this.isSaving = true;

     
       const retVal=await highlightService.save(highlight);
        console.log("retVal", retVal);
       this.highlight=retVal;
    } catch (error) {
      throw error;
    } finally {
      this.isSaving = false;
    }
  }
}


const highlightStore = new HighLightStore();
export default highlightStore;

